const MAX_ITERATIONS = 10 // to not pollute user memory we define max iterations count

export const withDelay = (fn, conditionFn, delay = 1500) => {
  let counter = 0

  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      try {
        if (conditionFn()) {
          fn()
          clearInterval(interval)
          resolve()
        }
        if (counter > MAX_ITERATIONS) {
          clearInterval(interval)
          resolve()
        }
        counter++
      } catch (e) {
        console.error(e)
        clearInterval(interval)
      }
    }, delay)
  })
}
